module.exports = __webpack_public_path__ + "img/email-campaigns.8499cc07.svg";